import { CoinBadgeV2 } from "@components/CoinBadgeV2"
import { ItemResponse } from "baaanggg"
import { Link } from "react-router-dom"

type Prop = {
    item: ItemResponse
}

export function MintableItemCard({ item }: Prop) {
    return <Link to={`/item/${item.id}/mint`}
        className="block rounded-2.5xl border border-jacarta-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-transparent dark:bg-gray-900">
        <figure className="relative">
            <img src={item.image} alt="item 4" className="w-full rounded-[0.625rem]"
                loading="lazy" />

            <div className="absolute left-3 -bottom-3">
                <div className="flex -space-x-2">
                    {
                        item.collection?.owner && <div>
                            <img src={item.collection.owner.thumbUrl ?? "/src/img/logo/transparant_logo.png"} alt="creator"
                                className="h-6 w-6 rounded-full border-2 border-white hover:border-accent dark:border-gray-400 dark:hover:border-jacarta-500" />
                        </div>
                    }

                </div>
            </div>
        </figure>
        <div className="mt-7 flex flex-wrap">
            {
                item.mintableItem?.prices?.map(price => <div className="mr-1.5 mb-1.5" key={price.coinId}>
                    <CoinBadgeV2 size="sm" amount={price.price} coinId={price.coinId} />
                </div>
                )
            }
        </div>
        <div className="mt-2 flex items-center justify-between">

            <span className="font-display text-base text-jacarta-700 hover:text-accent dark:text-white">
                {item.name}
            </span>
        </div>
    </Link>
}